<div class="col-md-4 list-settings-sidebar" *ngIf="!newView && !newGroup">
  <list-settings-sidebar
    [selectedSettingsItem]="selectedSettingsItem"
    [views]="data.userViews"
    [groups]="data.groups"
    (settingsItemSelected)="settingsItemSelected($event)"
    (deleteViewEvent)="deleteView($event)"
    (deleteGroupEvent)="deleteGroup($event)"
  ></list-settings-sidebar>
</div>
<div
  class="list-settings-detail-panel"
  [ngClass]="newView || newGroup ? 'col-md-12' : 'col-md-8'"
>
  <div class="close-btn">
    <button
      mat-raised-button
      class="view-action-btn pull-right"
      (click)="closeModal()"
      alt="Close modal"
    >
      CLOSE
    </button>
  </div>
  <div class="main-body">
    <list-settings-details-panel
      [selectedItem]="selectedSettingsItem"
      [selectedItemType]="selectedSettingsItemType"
      [columns]="data.columns"
      [schools]="data.schools"
      [isAdminUser]="data.isAdminUser"
      [isSLUser]="data.isSLUser"
      [isStarterUser]="data.isStarterUser"
      [error]="error"
      [isSaveSuccessful]="isSaveSuccessful"
      [views]="data.userViews"
      [groups]="data.groups"
      [hasChangesToSave]="hasChangesToSave"
      (saveViewEvent)="
        selectedSettingsItemType == 'view'
          ? saveView($event)
          : saveGroup($event)
      "
      (changesToSaveEvent)="updateChangesToSave($event)"
      (updatedItemEvent)="updatedItemChange($event)"
      *ngIf="selectedSettingsItem"
    >
    </list-settings-details-panel>
    <p
      *ngIf="
        (!data.userViews || data.userViews.length == 0) &&
        (!data.groups || data.groups.length == 0)
      "
    >
      No views or groups exist. To create one, change the filters or sort
      options on the dashboard.
    </p>
  </div>
</div>
